<template>
  <div>
    <div class="row-item">
        <div class="left">司法风险</div>
         <div class="right">{{ form.legalRisk }}</div>
    </div>
    <div class="row-item">
        <div class="left">经营风险</div>
         <div class="right">{{ form.engageRisk }}</div>
    </div>
    <div class="row-item">
        <div class="left">企业发展</div>
         <div class="right">{{ form.firmDevelopment }}</div>
    </div>
    <div class="row-item">
        <div class="left">经营状况</div>
         <div class="right">{{ form.operateStatus }}</div>
    </div>
    <div class="row-item">
        <div class="left">知识产权</div>
         <div class="right">{{ form.knowledgePoint }}</div>
    </div>
    <div class="danger-box">
      <div class="danger-item" v-if="form.riskLevel == 1">
        <img :src='dangerList[0].url' />
        <div>{{dangerList[0].name}}</div>
      </div>
      <div class="danger-item" v-if="form.riskLevel == 2">
        <img :src='dangerList[1].url' />
        <div>{{dangerList[1].name}}</div>
      </div>
      <div class="danger-item" v-if="form.riskLevel == 3">
        <img :src='dangerList[2].url' />
        <div>{{dangerList[2].name}}</div>
      </div>
      <div class="danger-item" v-if="form.riskLevel == 4">
        <img :src='dangerList[3].url' />
        <div>{{dangerList[3].name}}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
data(){
    return{
        dangerList:[
            {
                id:1,
                name:'低风险',
                url:require('../assets/images/danger1.png')
            },
            {
                id:2,
                name:'一般风险',
                url:require('../assets/images/danger2.png')
            },
            {
                id:3,
                name:'较大风险',
                url:require('../assets/images/danger3.png')
            },
            {
                id:4,
                name:'重大风险',
                url:require('../assets/images/danger4.png')
            },
        ]
    }
}
}
</script>

<style scoped lang='scss'>
.row-item{
    display: flex;
    color: #fff;
    margin: 0rem  0rem  0.07rem;
    border: 1px solid #01c5f3;
    .left{
        padding: 0.1rem 0;
        width: 20%;
        text-align: center;
        background:linear-gradient(to right,rgba(0,205,252,.8),rgba(11,38,76,.4 ));
    }
    .right{
        padding: 0.1rem 0;
        width: 80%;
    }
}
 .danger-box{
    display: flex;
    align-items: center;
    font-size: 0.2rem;
    font-weight: 550;
    margin: 0.5rem 0;
   justify-content: center;
    .danger-item{
        width: 25%;
        text-align: center;
    }
    .danger-item:nth-child(1){
        color: #6694CD;
    }
     .danger-item:nth-child(2){
        color: #EADE17;
    }
     .danger-item:nth-child(3){
        color: #F67D25;
    }
     .danger-item:nth-child(4){
        color: #FC1818;
    }
 }
</style>
